import {
  getMockVehicleDetail,
  MOCK_STAT_CARDS,
  MOCK_VEHICLES,
} from "../data";
import { STATUS_TABS, VehicleStatusesState, YARD_STATUS_TABS } from "../types";

const firstVehicle = MOCK_VEHICLES[0];

export const initialState: VehicleStatusesState = {
  loading: false,
  searchQuery: "",
  yardSearchQuery: "",
  isSearchExtended: false,
  isYardSearchExtended: false,
  activeStatusTab: STATUS_TABS[1],
  activeYardTab: YARD_STATUS_TABS[YARD_STATUS_TABS.length - 1],
  activeDetailTab: 4,
  statCards: MOCK_STAT_CARDS,
  vehicles: MOCK_VEHICLES,
  selectedVehicleId: firstVehicle ? firstVehicle.id : null,
  selectedVehicleDetail: firstVehicle
    ? getMockVehicleDetail(firstVehicle)
    : null,
};
